import { combineReducers } from "@reduxjs/toolkit";
import loginReducer from "../pages/Login/actions/LoginActions";

const rootReducer = combineReducers(
    {
    login : loginReducer
})

export default rootReducer